import React from 'react';
import { Link } from 'react-router-dom';

const FEATURES = [
  {
    title: 'Test on development devices',
    body: 'Internal tests run on staff accounts and devices on the development track, before anything reaches beta.',
  },
  {
    title: 'Get firmware first',
    body: 'Dev and alpha firmware land here first so we can catch issues on our own hardware.',
  },
  {
    title: 'Keep beta separate',
    body: 'Internal testing has its own reports and database. Nothing you do here appears in the beta program.',
  },
];

const TestingLandingPage: React.FC = () => {
  return (
    <main className="beta-landing">
      <section className="beta-landing-hero">
        <span className="beta-portal-badge">Internal Testing</span>
        <h1>Welcome to Internal Testing</h1>
        <p className="beta-landing-lead">
          Internal tests for staff and development devices — separate from the beta program.
        </p>
      </section>

      <section className="beta-landing-features" aria-label="Internal testing">
        {FEATURES.map((feature) => (
          <article key={feature.title} className="beta-landing-card">
            <h2>{feature.title}</h2>
            <p>{feature.body}</p>
          </article>
        ))}
      </section>

      <section className="beta-landing-cta testing-landing-cta">
        <h2>Already an internal tester?</h2>
        <p>
          Sign in with the account an administrator granted access to. There is
          no self-serve sign up.
        </p>
        <Link to="/login" className="btn beta-landing-cta-btn">
          Log in
        </Link>
      </section>
    </main>
  );
};

export default TestingLandingPage;
